import { gql } from "@apollo/client";

export const CREATE_ROUND = gql`
  mutation CreateRoundMutation($input: CreateRoundInput!) {
    createRound(input: $input) {
      ok
      error
      id
    }
  }
`;

export const ROUNDS = gql`
  query RoundsQuery($where: RoundsFiltersInput!) {
    rounds(where: $where) {
      hasMore
      total
      results {
        id

        hour

        site {
          id
          name
          url
        }

        sentinel {
          id
          ip
        }
      }
    }
  }
`;

export const ROUND = gql`
  query RoundQuery($id: Int!) {
    round(id: $id) {
      ok
      error
      result {
        id
        hour

        siteId
        site {
          id
          name
          url
        }

        sentinelId
        sentinel {
          id
          ip
        }
      }
    }
  }
`;

export const UPDATE_ROUND = gql`
  mutation UpdateRoundMutation($id: Int!, $input: UpdateRoundInput!) {
    updateRound(id: $id, input: $input) {
      ok
      error
    }
  }
`;
